export const getErrorMessage = (error: unknown): string => {
  if (error && 'message' in (error as any)) {
    return (error as any).message;
  } else if (error && 'data' in (error as any)) {
    return error.data.message;
  } else if (error instanceof Error) {
    return error.message;
  } else {
    return `${error}`;
  }
};
